import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../services/axiosInstance';
import {
    Box,
    Button,
    Card,
    CardContent,
    Stack,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';

const assessmentLabels = {
    'resource-capability': 'Resource Capability Assessment',
    'project-delivery': 'Project Delivery Assessment',
    'platform-solution': 'Platform Solution Assessment',
    'testing': 'Testing Assessment'
};

const HomePage = () => {
    const [assignedApplications, setAssignedApplications] = useState([]);
    const [assessmentStatuses, setAssessmentStatuses] = useState({});
    const navigate = useNavigate();
    const params = useParams();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [statusesLoaded, setStatusesLoaded] = useState(false);

    useEffect(() => {
         console.log('useEffect fired, userId:', params.userId);
        const fetchAssignedAppsAndStatuses = async () => {
            console.log('fetchAssignedAppsAndStatuses called');
            try {
                const res = await axiosInstance.get(`/userinfo/${params.userId}/assignedApplications`);
                const apps = res.data.assignedApplications || [];
                setAssignedApplications(apps);

                const statusMap = {};
                for (const app of apps) {
                    try {
                        const statusRes = await axiosInstance.get(`/users/status/${params.userId}/${app}`);
                        statusMap[app] = statusRes.data.status;
                    } catch (err) {
                        console.error(`Failed to fetch status for ${app}:`, err);
                        statusMap[app] = null;
                    }
                }
                setAssessmentStatuses(statusMap);
                setStatusesLoaded(true); 
            } catch (error) {
                console.error('Error fetching assigned applications:', error);
            }
        };

        fetchAssignedAppsAndStatuses();
    }, [params.userId]);

    const handleStart = (application) => {
        navigate(`/assessment-info/${params.userId}/${application}`);
    };

const getButtonLabel = (app, status) => {
    const label = assessmentLabels[app] || app;
    if (!statusesLoaded) return '...';          // show loading until statuses are ready
    if (status === -1) return 'Completed!';
    if (status == null) return `Start ${label}`;
    return `Continue ${label}`;
};

    return (
        <Box
            sx={{
                minHeight: 'calc(100vh - 32px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                py: 4,
                backgroundColor: '#f9f9fb'
            }}
        >
            <Card sx={{ width: isSmallScreen ? '100%' : '700px', p: 4, borderRadius: 4 }}>
                <CardContent>
                    <Typography variant="h4" align="center" gutterBottom>
                        Welcome!
                    </Typography>
                    <Typography variant="body1" align="center" sx={{ mb: 4 }}>
                        You have been assigned one or more assessments to complete by your admin.
                        Please click on the buttons below to begin.
                    </Typography>
                    <Stack spacing={2}>
                        {assignedApplications.map((app) => {
                            const status = assessmentStatuses[app];
                            const isComplete = status === -1;
                            return (
                                <Button
                                    key={app}
                                    variant="contained"
                                    fullWidth
                                    color="primary"
                                    onClick={() => handleStart(app)}
                                    disabled={isComplete || !statusesLoaded}
                                    sx={{
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        fontSize: '1rem',
                                    }}
                                >
                                    {getButtonLabel(app, status)}
                                </Button>
                            );
                        })}
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
};

export default HomePage;
